import dynamic from 'next/dynamic';
export default dynamic(() =>
	import(/* webpackChunkName:"FooterNavigationContent" */ './FooterNavigationContent').then((mod) => mod.default)
);
